import { Badge } from '@/components/ui/badge'

interface Props {
  status: 'active' | 'gone' | string
}

export function StatusBadge({ status }: Props) {
  const variant =
    status === 'active' ? 'success' : status === 'gone' ? 'destructive' : 'secondary'
  return <Badge variant={variant as 'success' | 'destructive' | 'secondary'}>{status}</Badge>
}
